import { render, staticRenderFns } from "./assetsType.vue?vue&type=template&id=9f06b166&"
import script from "./assetsType.vue?vue&type=script&lang=js&"
export * from "./assetsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports